<template>
  <div id="Cache">
    <b-row class="pt-3">
      <b-col class="new-config">
        <b-form id="cache-form" class="new-test-form">
          <b-form-row>
            <b-col sm="12">
              <b-form-group>
                <p-check v-for="item in cacheItems" :key="item.key" class="p-icon p-smooth d-block mb-3" color="info" v-model="item.checked" :disabled="isLoading">
                  <i slot="extra" class="icon material-icons">done</i>
                  {{ item.name }}
                </p-check>
              </b-form-group>
            </b-col>
          </b-form-row>

          <b-form-row class="submit">
            <b-col cols="12" sm="12" class="d-flex">
              <b-button type="button" variant="primary" :disabled="isLoading" @click.prevent="save">Purge selection</b-button>
            </b-col>
          </b-form-row>
        </b-form>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { sweepAllByKey } from '@/api/web'
export default {
  name: 'Cache',
  data () {
    return {
      cacheItems: [
        {
          name: 'Recharge',
          key: 'recharge',
          checked: false
        },
        {
          name: 'Jobs',
          key: 'jobs',
          checked: false
        },
        {
          name: 'Storyblok',
          key: 'storyblok',
          checked: false
        }
      ]
    }
  },
  computed: {
    ...mapGetters({
      isLoading: 'loader/isLoading'
    })
  },
  methods: {
    save () {
      var promises = []
      this.cacheItems.forEach((item) => {
        if (item.checked) {
          promises.push(sweepAllByKey(item.key))
        }
      })
      Promise.all(promises).then(() => {
        this.cacheItems.forEach((item) => {
          item.checked = false
        })
      }).catch(() => {
        this.$toastr.e('Some of the key could not be cleaned!')
      })
    }
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/views/config/ConfigCachePurge.vue